@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
.spinner {
  aspect-ratio: 1;
  background: var(--colorPrimary);
  border-radius: 50%;
  padding: 8px;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: spin 1.5s infinite linear;
}